module.exports = __webpack_public_path__ + "assets/img/icon4.af9e16bf.png";